"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNavbarPagesUrls = void 0;
var config_1 = require("../../config");
var Navbar_types_1 = require("./Navbar.types");
var getNavbarPagesUrls = function () {
    var _a;
    return _a = {},
        _a[Navbar_types_1.NavbarPages.MARKETPLACE] = config_1.config.get('MARKETPLACE_URL'),
        _a[Navbar_types_1.NavbarPages.CREATE] = config_1.config.get('LANDING_CREATORS_URL'),
        _a[Navbar_types_1.NavbarPages.EXPLORE] = config_1.config.get('EVENTS_URL'),
        _a[Navbar_types_1.NavbarPages.LEARN] = config_1.config.get('DOCS_URL'),
        _a[Navbar_types_1.NavbarPages.GOVERNANCE] = config_1.config.get('GOVERNANCE_URL'),
        _a;
};
exports.getNavbarPagesUrls = getNavbarPagesUrls;
